import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const Content = styled.div``;

const IllustrationModal = styled.div`
  display: flex;
  gap: 16px;

  ${DEVICE.mobile.max} {
    flex-direction: column;
  }
`;

export { Content, IllustrationModal };
